import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import  '../../core/js/_base';
import App from '../../core/js/App';
import {} from './controllers/index';


window.addEventListener("load", () => {
    window.App = new App();
    window.App.run();
});